/**
 * RMFF News Widget TypeScript
 */
function initNewsWidget() {
    // Initialize all news widgets on the page
    var newsWidgets = document.querySelectorAll('.rmff-news-widget');
    newsWidgets.forEach(function (widget) {
        initNewsWidgetInstance(widget);
    });
}
function initNewsWidgetInstance(widget) {
    // Initialize dropdown functionality
    initCustomDropdowns(widget);
    // Initialize filter functionality
    initFilterFunctionality(widget);
    // Initialize load more functionality
    initLoadMoreFunctionality(widget);
    // Initialize active filters UI (pills)
    initActiveFiltersUI(widget);
}
function initCustomDropdowns(widget) {
    var dropdowns = widget.querySelectorAll('.rmff-custom-dropdown');
    dropdowns.forEach(function (dropdown) {
        var trigger = dropdown.querySelector('.rmff-dropdown-trigger');
        var content = dropdown.querySelector('.rmff-dropdown-content');
        if (!trigger || !content)
            return;
        // Toggle dropdown
        trigger.addEventListener('click', function (e) {
            e.stopPropagation();
            // Close other dropdowns
            dropdowns.forEach(function (otherDropdown) {
                if (otherDropdown !== dropdown) {
                    var otherTrigger = otherDropdown.querySelector('.rmff-dropdown-trigger');
                    var otherContent = otherDropdown.querySelector('.rmff-dropdown-content');
                    if (otherTrigger && otherContent) {
                        otherTrigger.classList.remove('active');
                        otherContent.classList.remove('active');
                    }
                }
            });
            // Toggle current dropdown
            trigger.classList.toggle('active');
            content.classList.toggle('active');
        });
        // Handle checkbox changes
        var checkboxes = content.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(function (checkbox) {
            checkbox.addEventListener('change', function () {
                updateDropdownText(dropdown);
                // Trigger filter update
                updateNewsFilter(widget);
            });
        });
        // Close dropdown when clicking outside
        document.addEventListener('click', function (e) {
            if (!dropdown.contains(e.target)) {
                trigger.classList.remove('active');
                content.classList.remove('active');
            }
        });
    });
}
function updateDropdownText(dropdown) {
    var _a, _b;
    var trigger = dropdown.querySelector('.rmff-dropdown-trigger');
    var textElement = trigger.querySelector('.rmff-dropdown-text');
    var checkboxes = dropdown.querySelectorAll('input[type="checkbox"]:checked');
    if (!textElement)
        return;
    var filterType = dropdown.getAttribute('data-filter');
    var text = '';
    if (checkboxes.length === 0) {
        text = filterType === 'focus-area' ? 'All Focus Areas' : 'All Content Types';
    }
    else if (checkboxes.length === 1) {
        var checkbox = checkboxes[0];
        var label = (_b = (_a = checkbox.closest('.rmff-checkbox-item')) === null || _a === void 0 ? void 0 : _a.querySelector('.rmff-checkbox-text')) === null || _b === void 0 ? void 0 : _b.textContent;
        text = label || checkbox.value;
    }
    else {
        text = "".concat(checkboxes.length, " selected");
    }
    textElement.textContent = text;
}
function initFilterFunctionality(widget) {
    // Initial filter state - show all items
    showAllItems(widget);
    // Add clear all filters link handler
    var clearAllLink = widget.querySelector('.rmff-clear-all-filters-link');
    if (clearAllLink) {
        clearAllLink.addEventListener('click', function (e) {
            e.preventDefault();
            clearAllFilters(widget);
            updateActiveFiltersUI(widget);
        });
    }
}
function updateNewsFilter(widget) {
    var filterData = getFilterData(widget);
    // Show loading indicator
    showLoadingIndicator(widget);
    // Make AJAX request
    makeAjaxRequest(widget, filterData);
}
function getFilterData(widget) {
    var focusAreaDropdown = widget.querySelector('[data-filter="focus-area"]');
    var contentTypeDropdown = widget.querySelector('[data-filter="content-type"]');
    var focus_areas = [];
    var content_types = [];
    // Get selected focus areas
    if (focusAreaDropdown) {
        var checkedBoxes = focusAreaDropdown.querySelectorAll('input[type="checkbox"]:checked');
        checkedBoxes.forEach(function (checkbox) {
            focus_areas.push(checkbox.value);
        });
    }
    // Get selected content types
    if (contentTypeDropdown) {
        var checkedBoxes = contentTypeDropdown.querySelectorAll('input[type="checkbox"]:checked');
        checkedBoxes.forEach(function (checkbox) {
            content_types.push(checkbox.value);
        });
    }
    return { focus_areas: focus_areas, content_types: content_types };
}
function showLoadingIndicator(widget) {
    var loadingElement = widget.querySelector('.rmff-news-loading');
    var gridContainer = widget.querySelector('.rmff-news-grid-container');
    if (loadingElement && gridContainer) {
        loadingElement.style.display = 'block';
        gridContainer.style.opacity = '0.5';
    }
}
function hideLoadingIndicator(widget) {
    var loadingElement = widget.querySelector('.rmff-news-loading');
    var gridContainer = widget.querySelector('.rmff-news-grid-container');
    if (loadingElement && gridContainer) {
        loadingElement.style.display = 'none';
        gridContainer.style.opacity = '1';
    }
}
function makeAjaxRequest(widget, filterData) {
    var _a, _b;
    var widgetId = widget.getAttribute('data-widget-id');
    var postsPerPage = widget.getAttribute('data-posts-per-page') || '6';
    var showExcerpt = widget.getAttribute('data-show-excerpt') || 'yes';
    var showCategories = widget.getAttribute('data-show-categories') || 'yes';
    var formData = new FormData();
    formData.append('action', 'filter_news_content');
    formData.append('nonce', ((_a = window.rmff_ajax) === null || _a === void 0 ? void 0 : _a.news_filter_nonce) || '');
    formData.append('posts_per_page', postsPerPage);
    formData.append('show_excerpt', showExcerpt);
    formData.append('show_categories', showCategories);
    formData.append('focus_areas', JSON.stringify(filterData.focus_areas));
    formData.append('content_types', JSON.stringify(filterData.content_types));
    fetch(((_b = window.rmff_ajax) === null || _b === void 0 ? void 0 : _b.ajax_url) || '', {
        method: 'POST',
        body: formData
    })
        .then(function (response) { return response.json(); })
        .then(function (data) {
        var _a;
        hideLoadingIndicator(widget);
        if (data.success) {
            updateNewsGrid(widget, data.data.html);
            updateResultsCounter(widget, data.data.total_found);
            updateActiveFiltersUI(widget);
            // Reset load more button offset and visibility
            // Count actual items rendered to determine if there might be more
            var loadMoreBtn = widget.querySelector('.rmff-load-more-btn');
            var postsPerPageNum = parseInt(postsPerPage);
            if (loadMoreBtn) {
                // Count the actual number of news items in the grid
                var grid = widget.querySelector('.rmff-news-grid');
                var itemCount = grid ? grid.querySelectorAll('.rmff-news-item').length : 0;
                // Set offset to the number of items currently displayed
                loadMoreBtn.dataset.offset = itemCount.toString();
                // Show/hide load more button
                // If we got exactly the requested number of items, there might be more
                // The load more handler will hide it if there are no more items
                var loadMoreContainer = widget.querySelector('.rmff-news-load-more');
                if (loadMoreContainer) {
                    // Show button if we got a full page of results (might have more)
                    // The load more handler will hide it if there are no more items
                    loadMoreContainer.style.display = itemCount >= postsPerPageNum ? 'block' : 'none';
                }
            }
        }
        else {
            console.error('Filter request failed:', (_a = data.data) === null || _a === void 0 ? void 0 : _a.message);
        }
    })
        .catch(function (error) {
        hideLoadingIndicator(widget);
        console.error('Filter request error:', error);
    });
}
function updateNewsGrid(widget, html) {
    var grid = widget.querySelector('.rmff-news-grid');
    if (grid) {
        grid.innerHTML = html;
        // Ensure all items are visible after AJAX update
        showAllItems(widget);
        // Re-initialize fade-in-up animations for new content
        reinitializeFadeInUpAnimations(widget);
        // Force a reflow to ensure rendering
        grid.offsetHeight;
    }
}
function reinitializeFadeInUpAnimations(container) {
    // Check if we're in Elementor editor
    var isElementorEditor = document.body.classList.contains('elementor-editor-active') ||
        document.body.classList.contains('elementor-editor') ||
        document.querySelector('.elementor-editor') ||
        window.location.search.includes('action=elementor') ||
        typeof window.elementorFrontend !== 'undefined' && window.elementorFrontend.isEditMode();
    // If in Elementor editor, show all elements immediately
    if (isElementorEditor) {
        container.querySelectorAll('.fade-in-up').forEach(function (element) {
            element.classList.add('fade-in-up--visible');
            element.classList.remove('fade-in-up');
        });
        return;
    }
    // Find all fade-in-up elements within the container
    var fadeInElements = container.querySelectorAll('.fade-in-up');
    if (fadeInElements.length === 0)
        return;
    // Create a new IntersectionObserver for the new elements
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var element_1 = entry.target;
                // Check if this element is part of a group of siblings
                var parent_1 = element_1.parentElement;
                if (parent_1) {
                    var siblings = Array.from(parent_1.querySelectorAll('.fade-in-up'));
                    var index = siblings.indexOf(element_1);
                    // Add staggered delay based on sibling position + 250ms initial delay
                    var delay = 250 + (index * 150);
                    setTimeout(function () {
                        element_1.classList.add('fade-in-up--visible');
                    }, delay);
                }
                else {
                    // No siblings, animate after 250ms initial delay
                    setTimeout(function () {
                        element_1.classList.add('fade-in-up--visible');
                    }, 250);
                }
                // Stop observing this element
                observer.unobserve(element_1);
            }
        });
    }, {
        threshold: 0.1, // Trigger when 10% of element is visible
        rootMargin: '0px 0px -50px 0px' // Start animation slightly before element is fully in view
    });
    // Observe all new fade-in-up elements
    fadeInElements.forEach(function (element) {
        observer.observe(element);
    });
}
function updateResultsCounter(widget, count) {
    var resultsCounter = widget.querySelector('.rmff-results-count');
    if (resultsCounter) {
        resultsCounter.textContent = count.toString();
    }
}
function showAllItems(widget) {
    var items = widget.querySelectorAll('.rmff-news-item');
    items.forEach(function (item) {
        item.classList.remove('hidden');
    });
}
function initLoadMoreFunctionality(widget) {
    var loadMoreBtn = widget.querySelector('.rmff-load-more-btn');
    if (!loadMoreBtn)
        return;
    // Initialize offset tracking to the number of posts already displayed
    var postsPerPage = parseInt(loadMoreBtn.dataset.postsPerPage || '6');
    loadMoreBtn.dataset.offset = postsPerPage.toString();
    loadMoreBtn.addEventListener('click', function () {
        var currentOffset = parseInt(loadMoreBtn.dataset.offset || '0');
        var currentFilterData = getFilterData(widget);
        loadMorePosts(widget, loadMoreBtn, currentOffset, currentFilterData);
    });
}
function loadMorePosts(widget, button, offset, filterData) {
    var _a, _b;
    // Show loading state
    button.disabled = true;
    button.classList.add('loading');
    // Check if nonce is available
    var nonce = ((_a = window.rmff_ajax) === null || _a === void 0 ? void 0 : _a.news_filter_nonce) || '';
    if (!nonce) {
        console.error('Load more error: Nonce is missing. The page may need to be refreshed.');
        button.disabled = false;
        button.classList.remove('loading');
        alert('Unable to load more posts. Please refresh the page and try again.');
        return;
    }
    var postsPerPage = widget.getAttribute('data-posts-per-page') || '6';
    var showExcerpt = widget.getAttribute('data-show-excerpt') || 'yes';
    var showCategories = widget.getAttribute('data-show-categories') || 'yes';
    var formData = new FormData();
    formData.append('action', 'load_more_news');
    formData.append('nonce', nonce);
    formData.append('posts_per_page', postsPerPage);
    formData.append('show_excerpt', showExcerpt);
    formData.append('show_categories', showCategories);
    formData.append('offset', offset.toString());
    formData.append('focus_areas', JSON.stringify(filterData.focus_areas));
    formData.append('content_types', JSON.stringify(filterData.content_types));
    fetch(((_b = window.rmff_ajax) === null || _b === void 0 ? void 0 : _b.ajax_url) || '', {
        method: 'POST',
        body: formData
    })
        .then(function (response) { return response.json(); })
        .then(function (data) {
        var _a;
        if (data.success) {
            appendNewsItems(widget, data.data.html);
            updateResultsCounterWithAddition(widget, data.data.items_loaded);
            updateLoadMoreButton(widget, button, data.data.has_more, data.data.new_offset);
            // Re-initialize fade-in-up animations for new content
            reinitializeFadeInUpAnimations(widget);
        }
        else {
            var errorMessage = ((_a = data.data) === null || _a === void 0 ? void 0 : _a.message) || 'Unknown error';
            console.error('Load more request failed:', errorMessage);
            // If nonce error, suggest refreshing the page
            if (errorMessage.toLowerCase().includes('nonce')) {
                alert('Session expired. Please refresh the page and try again.');
            }
        }
    })
        .catch(function (error) {
        console.error('Load more request error:', error);
        alert('An error occurred while loading more posts. Please try again.');
    })
        .finally(function () {
        // Hide loading state
        button.disabled = false;
        button.classList.remove('loading');
    });
}
function appendNewsItems(widget, html) {
    var gridContainer = widget.querySelector('.rmff-news-grid');
    if (gridContainer) {
        gridContainer.insertAdjacentHTML('beforeend', html);
    }
}
function updateResultsCounterWithAddition(widget, newItemsCount) {
    var resultsCounter = widget.querySelector('.rmff-results-count');
    if (resultsCounter) {
        var currentCount = parseInt(resultsCounter.textContent || '0');
        var newCount = currentCount + newItemsCount;
        resultsCounter.textContent = newCount.toString();
    }
}
function updateLoadMoreButton(widget, button, hasMore, newOffset) {
    var loadMoreContainer = widget.querySelector('.rmff-news-load-more');
    if (hasMore) {
        // Update offset for next load
        button.dataset.offset = newOffset.toString();
        loadMoreContainer.style.display = 'block';
    }
    else {
        // Hide button if no more posts
        loadMoreContainer.style.display = 'none';
    }
}
// -----------------------------
// Active Filters UI (pills + visibility)
// -----------------------------
function initActiveFiltersUI(widget) {
    // Clicking a pill removes that filter
    var pillsContainer = widget.querySelector('.rmff-filter-pills');
    if (!pillsContainer)
        return;
    pillsContainer.addEventListener('click', function (e) {
        var target = e.target;
        var pill = target.closest('.rmff-filter-pill');
        if (!pill)
            return;
        var type = pill.getAttribute('data-type');
        var value = pill.getAttribute('data-value') || '';
        if (!type)
            return;
        if (type === 'focus-area') {
            var focusAreaDropdown = widget.querySelector('[data-filter="focus-area"]');
            if (focusAreaDropdown) {
                var checkbox = focusAreaDropdown.querySelector("input[value=\"".concat(CSS.escape(value), "\"]"));
                if (checkbox) {
                    checkbox.checked = false;
                    updateDropdownText(focusAreaDropdown);
                }
            }
        }
        else if (type === 'content-type') {
            var contentTypeDropdown = widget.querySelector('[data-filter="content-type"]');
            if (contentTypeDropdown) {
                var checkbox = contentTypeDropdown.querySelector("input[value=\"".concat(CSS.escape(value), "\"]"));
                if (checkbox) {
                    checkbox.checked = false;
                    updateDropdownText(contentTypeDropdown);
                }
            }
        }
        updateNewsFilter(widget);
        updateActiveFiltersUI(widget);
    });
}
function updateActiveFiltersUI(widget) {
    var pillsContainer = widget.querySelector('.rmff-filter-pills');
    var activeFiltersRow = widget.querySelector('.rmff-active-filters');
    if (!pillsContainer || !activeFiltersRow)
        return;
    var filters = getFilterData(widget);
    var hasActive = filters.focus_areas.length > 0 || filters.content_types.length > 0;
    // Show/hide active filters row
    activeFiltersRow.style.display = hasActive ? 'flex' : 'none';
    // Update pills
    pillsContainer.innerHTML = '';
    // Add focus area pills
    filters.focus_areas.forEach(function (slug) {
        var _a, _b;
        var focusAreaDropdown = widget.querySelector('[data-filter="focus-area"]');
        if (focusAreaDropdown) {
            var checkbox = focusAreaDropdown.querySelector("input[value=\"".concat(CSS.escape(slug), "\"]"));
            if (checkbox) {
                var label = ((_b = (_a = checkbox.closest('.rmff-checkbox-item')) === null || _a === void 0 ? void 0 : _a.querySelector('.rmff-checkbox-text')) === null || _b === void 0 ? void 0 : _b.textContent) || slug;
                pillsContainer.appendChild(createNewsPill('focus-area', slug, label));
            }
        }
    });
    // Add content type pills
    filters.content_types.forEach(function (type) {
        var _a, _b;
        var contentTypeDropdown = widget.querySelector('[data-filter="content-type"]');
        if (contentTypeDropdown) {
            var checkbox = contentTypeDropdown.querySelector("input[value=\"".concat(CSS.escape(type), "\"]"));
            if (checkbox) {
                var label = ((_b = (_a = checkbox.closest('.rmff-checkbox-item')) === null || _a === void 0 ? void 0 : _a.querySelector('.rmff-checkbox-text')) === null || _b === void 0 ? void 0 : _b.textContent) || type;
                pillsContainer.appendChild(createNewsPill('content-type', type, label));
            }
        }
    });
}
function createNewsPill(type, value, label) {
    var pill = document.createElement('div');
    pill.className = 'rmff-filter-pill';
    pill.setAttribute('data-type', type);
    pill.setAttribute('data-value', value);
    pill.innerHTML = "<span>".concat(label, "</span><button type=\"button\" class=\"rmff-pill-remove\" aria-label=\"Remove ").concat(type, " filter\">\u00D7</button>");
    return pill;
}
function clearAllFilters(widget) {
    // Uncheck all focus area checkboxes
    var focusAreaDropdown = widget.querySelector('[data-filter="focus-area"]');
    if (focusAreaDropdown) {
        var checkboxes = focusAreaDropdown.querySelectorAll('input[type="checkbox"]:checked');
        checkboxes.forEach(function (checkbox) {
            checkbox.checked = false;
        });
        updateDropdownText(focusAreaDropdown);
    }
    // Uncheck all content type checkboxes
    var contentTypeDropdown = widget.querySelector('[data-filter="content-type"]');
    if (contentTypeDropdown) {
        var checkboxes = contentTypeDropdown.querySelectorAll('input[type="checkbox"]:checked');
        checkboxes.forEach(function (checkbox) {
            checkbox.checked = false;
        });
        updateDropdownText(contentTypeDropdown);
    }
    // Trigger filter update
    updateNewsFilter(widget);
}
// Export for use in index.ts
export { initNewsWidget };
